import _ from "lodash";
import { EMPTY_GERBER_FILE_MAPPING } from "../../index";
import { ZippedFiles } from "../readGerberZip";
import { UploadConfig } from "../../../../../reducers/uploadedBoard";

export function getSuggestionsFromFileMappingFile(
  zippedFiles: ZippedFiles,
): UploadConfig {
  const gerberFileMapping = _.cloneDeep(EMPTY_GERBER_FILE_MAPPING);
  if (zippedFiles.fileMappingFile !== undefined) {
    Object.entries(
      JSON.parse(zippedFiles.fileMappingFile.content as string) as {
        [key: string]: string | string[];
      },
    ).map(([key, value]) => {
      // In case any of the values are null when they shouldn't be, use defaults
      gerberFileMapping[key] = value || gerberFileMapping[key]!;
    });
  }
  return {
    gerber_file_layer_mapping: gerberFileMapping,
    bom_file_info: null,
    pnp_file_info: null,
    assembly_drawing: null,
    fab_drawing: null,
    reference_file: null,
  };
}
